/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import FontAwesome from 'react-fontawesome';
import s from './Footer.css';

class Footer extends React.Component {
  render() {
    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className={`${s.column} ${s.columnSpan35}`}>
            <a className={`${s.link} ${s.flex}`} href="/">
              <img
                src="/images/logo_footer.svg"
                width="88"
                height="60"
                alt="Maybricks Sdn Bhd"
              />
              <div className={s.title}>
                <div className={s.titleCn}>大馬磚業有限公司</div>
                <div className={s.titleEn}>Maybricks Sdn Bhd</div>
              </div>
            </a>
          </div>
          <div className={`${s.column} ${s.columnSpan30}`}>
            <div className={s.titleIso}>ISO 9001 : 2015</div>
            <div className={`${s.flex} ${s.flexCenter}`}>
              <img
                className={s.imageIso}
                src="/images/logo_tqcsi.png"
                alt="TQCSI"
              />
              <img
                className={s.imageIso}
                src="/images/logo_jas-anz.png"
                alt="JAS-ANZ"
              />
            </div>
            <div className={s.titleIsoSmall}>Certificate No. MY030-QC</div>
          </div>
          <div className={s.column}>
            <div className={s.titleHeadquarter}>Kulai Headquarter</div>
            <ul className="fa-ul">
              <li>
                <FontAwesome className="fa-li" name="map-marker" />Batu 36,
                Jalan Air Hitam, Bukit Batu<br />81000 Kulai, Johor, Malaysia.
              </li>
              <li>
                <FontAwesome className="fa-li" name="phone" />
                <a href="tel:+6076511022">(60) 7 651 1022</a>,&nbsp;
                <a href="tel:+6076511186">651 1186</a>,&nbsp;
                <a href="tel:+6076512210">651 2210</a>
              </li>
              <li>
                <FontAwesome className="fa-li" name="fax" />
                <a href="tel:+6076512818">(60) 7 651 2818</a>
              </li>
              <li>
                <FontAwesome className="fa-li" name="envelope" />
                <a href="mailto:maybrickskulai@gmail.com">
                  maybrickskulai@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js